import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOffAltOutlinedIcon from "@mui/icons-material/ThumbDownOffAltOutlined";
import ReplyOutlinedIcon from "@mui/icons-material/ReplyOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import Comments from "../components/Comments";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchFailure, fetchSuccess, like, dislike } from "../redux/videoSlice";
import { format } from "timeago.js";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { subscribe } from "../redux/userSlice";
import Recomendation from "../components/Recomendation";
import { createNotif } from "../redux/apiCalls";
import { publicRequest, userRequest } from "../requestMethods";

const Container = styled.div`
  display: flex;
  gap: 24px;
`;

const Content = styled.div`
  flex: 5;
`;

const VideoWrapper = styled.div``;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.text};
`;

const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const Info = styled.div`
  color: ${({ theme }) => theme.textSoft};
  @media only screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 20px;
  color: ${({ theme }) => theme.text};
  @media only screen and (max-width: 767px) {
    align-self: center;
  }
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
`;

const Hr = styled.hr`
  margin: 15px 0px;
  border: 0.5px solid ${({ theme }) => theme.soft};
`;

const Channel = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ChannelInfo = styled.div`
  display: flex;
  gap: 20px;
`;
const Image = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

const ChannelDetail = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.text};
`;
const ChannelName = styled.span`
  font-weight: 500;
`;
const ChannelCounter = styled.span`
  margin-top: 5px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.textSoft};
  font-size: 12px;
`;
const Description = styled.p`
  font-size: 14px;
`;
const Subscribe = styled.button`
  background-color: #cc1a00;
  font-weight: 500;
  color: white;
  border: none;
  border-radius: 3px;
  height: max-content;
  padding: 10px 20px;
  cursor: pointer;
`;

const VideoFrame = styled.video`
  max-height: 720px;
  width: 100%;
  object-fit: cover;
`;

const DeleteVideo = styled.button`
  background-color: #ffa600;
  font-weight: 500;
  color: black;
  border: 1px solid black;
  border-radius: 3px;
  height: max-content;
  padding: 10px 20px;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 5px;
  cursor: pointer;
  &:hover {
    background-color: red;
  }
  @media only screen and (max-width: 767px) {
    font-size: 12px;
  }
`;

const VideoButtons = styled.div`
  display: flex;
  gap: 10px;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const Error = styled.span`
  font-size: 18px;
  font-size: 500;
  background-color: #1db63e;
  color: white;
  display: flex;
  justify-content: center;
  text-align: center;
  padding: 10px 0px;
`;

const Video = () => {
  const [channel, setChannel] = useState({});
  const [smDisplay, setSmDisplay] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);
  const { currentVideo } = useSelector((state) => state.video);
  const videoId = location.pathname.split("/")[2];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const videoRes = await publicRequest.get(`/videos/find/${videoId}`);
        const channelRes = await userRequest.get(
          `/users/find/${videoRes?.data.userId}`
        );
        setChannel(channelRes.data);
        dispatch(fetchSuccess(videoRes.data));
      } catch (err) {
        dispatch(fetchFailure());
      }
    };
    fetchData();
  }, [videoId, dispatch]);

  useEffect(() => {
    const addView = async () => {
      await userRequest.put(`/videos/view/${currentVideo?._id}`);
    };
    addView();
  }, [currentVideo?._id]);

  const handleLike = async () => {
    await userRequest.put(`/users/like/${currentVideo?._id}`);
    dispatch(like(currentUser?._id));
    createNotif(dispatch, currentVideo?._id);
  };

  const handleDislike = async () => {
    await userRequest.put(`/users/dislike/${currentVideo?._id}`);
    dispatch(dislike(currentUser?._id));
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (currentUser?.subscribersUsers?.includes(channel?._id)) {
      await userRequest.put(`/users/unsub/${channel?._id}`);
      dispatch(subscribe(channel?._id));
    } else {
      await userRequest.put(`/users/sub/${channel?._id}`);
      dispatch(subscribe(channel?._id));
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    const deleteVideo = async (videoId) => {
      try {
        const res = await userRequest
          .delete(`/videos/${videoId}`)
          .then((response) => {
            setMessage(response.data);
          });
      } catch (err) {
        console.log(err);
      }
    };
    deleteVideo(currentVideo?._id);
  };

  useEffect(() => {
    if (window.innerWidth > 1024) {
      setSmDisplay(false);
    } else {
      setSmDisplay(true);
    }
  }, []);

  return (
    <Container>
      <Content>
        <VideoWrapper>
          <VideoFrame src={currentVideo?.videoUrl} controls autoPlay />
        </VideoWrapper>
        {message && <Error>{message}</Error>}
        <Title>{currentVideo?.title}</Title>
        <Details>
          <Info>
            {currentVideo?.views} views • {format(currentVideo?.createdAt)}
          </Info>
          <Buttons>
            <Button onClick={handleLike}>
              {currentVideo?.likes?.includes(currentUser?._id) ? (
                <ThumbUpIcon />
              ) : (
                <ThumbUpOutlinedIcon />
              )}
              {currentVideo?.likes?.length}
            </Button>

            <Button onClick={handleDislike}>
              {currentVideo?.dislikes?.includes(currentUser?._id) ? (
                <ThumbDownIcon />
              ) : (
                <ThumbDownOffAltOutlinedIcon />
              )}
              {currentVideo?.dislikes?.length}
            </Button>
            <Button style={{ cursor: "not-allowed" }}>
              <ReplyOutlinedIcon /> Share
            </Button>
            <Button style={{ cursor: "not-allowed" }}>
              <AddTaskOutlinedIcon /> Save
            </Button>
          </Buttons>
        </Details>
        <Hr />
        <Channel>
          <ChannelInfo>
            <Image
              src={
                channel?.img
                  ? channel?.img
                  : "https://refugedulacdulou.com/wp-content/uploads/2019/01/avatar-anonyme.png"
              }
            />
            <ChannelDetail>
              <ChannelName>{channel?.name}</ChannelName>
              <ChannelCounter>
                {channel?.subscribers} Subscribers
              </ChannelCounter>
              <Description>{currentVideo?.desc}</Description>
            </ChannelDetail>
          </ChannelInfo>
          <VideoButtons>
            {currentUser?._id === currentVideo?.userId ? (
              <DeleteVideo
                style={{
                  cursor: currentUser ? "pointer" : "not-allowed",
                }}
                onClick={handleDelete}
              >
                <DeleteOutlineIcon />
                DELETE VIDEO
              </DeleteVideo>
            ) : (
              <Subscribe
                style={{
                  cursor: currentUser ? "pointer" : "not-allowed",
                }}
                onClick={handleSubscribe}
              >
                {currentUser?.subscribersUsers?.includes(channel?._id)
                  ? "SUBSCRIBED"
                  : "SUBSCRIBE"}
              </Subscribe>
            )}
          </VideoButtons>
        </Channel>
        <Hr />
        <Comments videoId={currentVideo?._id} />
        {smDisplay && <Recomendation tags={currentVideo?.tags} />}
      </Content>
      {!smDisplay && <Recomendation tags={currentVideo?.tags} />}
    </Container>
  );
};

export default Video;
